import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Banner from "../banners";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Calculator from "../modals/Calculator";

export default function Footer() {
  const { t } = useTranslation();
  const [opener, setOpener] = useState<{ calc?: boolean }>({
    calc: false,
  });

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-12">
            <Banner src="/images/logo.png" width="116px" />
            <h6 className="size-7 my-3 text-bold lh-24 natural-3">
              {t("service_foreign_stores")}
            </h6>
            <h6 className="size-8 mb-3 text-bold lh-24 natural-4">
              {t("after_registration_30")}
            </h6>
            <div className="d-flex-center">
              <a href="#" target="_blank">
                <img src="/icons/twitter.svg" alt="twitter" />
              </a>
              <a href="#" className="mx-3" target="_blank">
                <img src="/icons/instagram.svg" alt="instagram" />
              </a>
              <a href="#" className="mr-3" target="_blank">
                <img src="/icons/facebook.svg" alt="facebook" />
              </a>
              <a href="#" target="_blank">
                <img src="/icons/vk.svg" alt="vk" />
              </a>
            </div>
          </div>
          <div className="offset-md-1 d-md-block d-none" />
          <div className="col-md-2 col-6">
            <h6 className="size-7 text-bold lh-24">{t("about_company")}</h6>
            <Link to="/services" className="size-8 natural-4 text-bold">
              {t("about_service")}
            </Link>
            <Link to="/rates" className="size-8 natural-4 text-bold">
              {t("tariffs_and_prices")}
            </Link>
            <Link to="/services" className="size-8 natural-4 text-bold">
              {t("our_services")}
            </Link>
            <HashLink to="/#reviews" className="size-8 natural-4 text-bold">
              {t("customer_reviews")}
            </HashLink>
            <Link to="/contacts" className="size-8 natural-4 text-bold">
              {t("contacts")}
            </Link>
          </div>
          <div className="col-md-2 col-6">
            <h6 className="size-7 text-bold lh-24">{t("for_buyers")}</h6>
            <Link to="/" className="size-8 natural-4 text-bold">
              {t("sales")}
            </Link>
            <Link to="/" className="size-8 natural-4 text-bold">
              {t("track_your_parcel")}
            </Link>
            <Link to="/help" className="size-8 natural-4 text-bold">
              {t("help")}
            </Link>
            <Link to="/" className="size-8 natural-4 text-bold">
              {t("help_with_purchasing")}
            </Link>
            <Link to="/" className="size-8 natural-4 text-bold">
              {t("restriction")}
            </Link>
            <Link to="/shops" className="size-8 natural-4 text-bold">
              {t("popular_stores")}
            </Link>
          </div>
          <div className="col-md-2 col-6">
            <h6 className="size-7 text-bold lh-24">{t("useful")}</h6>
            <Link to="/" className="size-8 natural-4 text-bold">
              {t("delivery")}
            </Link>
            <Link to="/" className="size-8 natural-4 text-bold">
              {t("sending_parcels")}
            </Link>
            <Link to="/" className="size-8 natural-4 text-bold">
              {t("customs_limits")}
            </Link>
            <Link to="/" className="size-8 natural-4 text-bold">
              {t("size_chart")}
            </Link>
            <button
              className="btn d-block bg-transparent p-0 size-8 natural-4 text-bold"
              onClick={() => setOpener({ calc: true })}
            >
              {t("cost_calculation")}
            </button>
          </div>
          <div className="col-md-2 col-6">
            <h6 className="size-7 text-bold lh-24">{t("contacts")}</h6>
            <a href="#" target="_blank" className="size-8 natural-4 text-bold">
              {t("usa_address")}
            </a>
            <a href="#" target="_blank" className="size-8 natural-4 text-bold">
              {t("support@fgf.uz")}
            </a>
          </div>
        </div>
        <hr className="mt-5 mb-0" />
        <div className="footer-bottom d-flex-center justify-content-between">
          <span className="size-9 natural-4 lh-20">{t("all_rights")}</span>
          <span className="size-9 lh-20">{t("we_use_cookie")}</span>
        </div>
      </div>
      {opener.calc && <Calculator modal={opener} setModal={setOpener} />}
    </footer>
  );
}
